{
  "billing": {
    "title": "Billing",
    "notAuthorized": "Only workspace owners can manage billing."
  },
  "balance": {
    "label": "Credit balance",
    "credits_one": "{{count}} credit",
    "credits_other": "{{count}} credits",
    "breakdown": "{{purchased}} purchased · {{granted}} gifted"
  },
  "topUp": {
    "cta": "Top up credits",
    "title": "Top up credits",
    "subtitle": "1 credit funds 1 profile.",
    "processing": "Processing…",
    "success": "Credits added",
    "settlementSlow": "This is taking longer than usual. Your purchase will appear shortly — check Billing.",
    "continue": "Continue",
    "back": "Back",
    "startFailed": "We couldn't start the payment. Please try again."
  },
  "amount": {
    "label": "How many credits?",
    "justEnough": "Just enough",
    "aBitExtra": "A bit extra",
    "roundUp": "Round up",
    "option": "{{credits}} for {{total}}",
    "unpriced_one": "{{count}} credit",
    "unpriced_other": "{{count}} credits"
  },
  "send": {
    "costSummary": "{{count}} invitations × {{unit}} = {{total}}. You have {{balance}} available.",
    "topUpAndSend": "Top up & send {{count}}"
  },
  "self": {
    "ctaHasCredits": "Profile yourself (uses 1 credit)",
    "ctaBuy": "Buy a profile for yourself — {{price}}",
    "askOwner": "Ask a workspace owner to top up credits.",
    "ctaBuyUnpriced": "Buy a profile for yourself"
  },
  "checkout": {
    "loadFailed": "We couldn't load the payment form.",
    "confirmFailed": "We couldn't reach Stripe to send the payment. Please try again.",
    "subtotal": "Credits",
    "tax": "Tax",
    "taxPending": "Calculated from your billing address",
    "total": "Total",
    "pay": "Pay {{total}}",
    "returnRetry": "If you didn't finish paying, you can try again from <billingLink>Billing</billingLink>."
  },
  "price": {
    "plusTax": "{{price}} + tax where applicable",
    "taxHint": "+ tax where applicable"
  },
  "history": {
    "title": "Purchase history",
    "empty": "No purchases yet.",
    "creditsColumn": "Credits",
    "date": "Date",
    "amount": "Amount",
    "invoice": "Invoice",
    "invoicePending": "Preparing…",
    "invoiceNotReady": "Your invoice is still being prepared. Please try again in a minute.",
    "downloadFailed": "Could not download the invoice. Please try again later."
  }
}
